// extracted by mini-css-extract-plugin
export default {"container":"item-table_container__p7x5l","switchContainer":"item-table_switchContainer__6IxKx"};